import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Emergency Triage")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "form-check custom-radio pb-1" }
const _hoisted_5 = ["id", "value", "checked"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Additional Emergency Preparedness Information")
], -1 /* HOISTED */)
const _hoisted_9 = { class: "form-check custom-checkbox pb-1" }
const _hoisted_10 = ["id", "value", "checked", "onChange"]
const _hoisted_11 = ["for"]
const _hoisted_12 = {
  key: 0,
  class: "d-flex bg-white flex-column ms-4 w-90 pb-4"
}
const _hoisted_13 = { class: "service-required-text-color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Admission Source and Timing (PDGM)",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emergencyTriageOptions, (option) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "form-check-input",
                id: `${option.value}-${option.label}`,
                value: option.value,
                checked: option.value === _ctx.referral.EmergencyPreparedness.Triage,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.EmergencyPreparedness.Triage) = $event))
              }, null, 8 /* PROPS */, _hoisted_5), [
                [_vModelRadio, _ctx.referral.EmergencyPreparedness.Triage]
              ]),
              _createElementVNode("label", {
                class: "form-check-label mb-2",
                for: `${option.value}-${option.label}`
              }, [
                _createElementVNode("small", null, _toDisplayString(option.label), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_6)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.additionalInformationOptionsEnum), (option) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: `${option.value}-${option.label}`,
                  value: option.value,
                  checked: _ctx.isAddInformationOptions(option.value),
                  onChange: ($event: any) => (_ctx.handleAddInformationOptions(option.value))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `${option.value}-${option.label}`
                }, [
                  _createElementVNode("small", null, _toDisplayString(option.label), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_11)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          (_ctx.isAddInformationOptions('3'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, "Medical Needs/Equipment: (" + _toDisplayString(_ctx.fetchMedicalNeedsCharLeft) + " characters left)", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control w-90",
                  placeholder: "Enter Admission Source",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.EmergencyPreparedness.MedicalNeeds) = $event)),
                  maxlength: "2000"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.EmergencyPreparedness.MedicalNeeds]
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}